<template>
  <div :class="['ad-container', {['has-overlay']: displayOverlay}, {['sponsored']: ad.fulfilled_sponsor_request}, { selected: adIsSelected}]" @click="selectAd">
    <div class="ad-title">
      <h5>{{ad.advertiser_name}}</h5>
    </div>
    <div class="ad-details" data-cy="ad-details">
      <div class="branded-image-container">
        <div v-if="displayOverlay" class="branded-image__overlay">
          <p class="branded-image__overlay-text">{{targetRecipientText}}</p>
        </div>

        <div class="branded-image">
          <img :src="adAttachmentUrl" class="thumbnail" />
        </div>
      </div>
      <div class="ad-settings">
        <div class="ad-expiration setting">
          <i class="flaticon-calendar"></i>
          <span>expires {{formattedDate}}
            <ad-expiration-warning :sendAtEnd="ad.send_at_end"></ad-expiration-warning>
          </span>
        </div>
        <div v-if="hasTimeRange" class="ad-time-range setting">
          <i class="flaticon-clock"></i>
          <div class="time-range-wrapper">
            <span>{{getTimeRange}}</span>
            <em>send time</em>
          </div>
        </div>
        <div v-if="ad.suggested_text" class="ad-suggested-text setting">
          <i class="flaticon-chat-1"/>

          <popper trigger="hover">
            <div class="popper">
              <div class="title">suggested text</div>
              <span class="content">{{ad.suggested_text}}</span>
            </div>
            <span slot="reference">suggested text</span>
          </popper>
        </div>

        <div v-if="shouldDisplayAdFilters" class="ad-filters">
          <div style="display:flex;align-items:center;">
            <fai :icon="['far', 'list-alt']" class="filter-icon"/>
            <span>requested filters:</span>
          </div>
          <ul class="filters-wrapper">
            <li v-for="(filter, index) in requestedFilters" :key="index">
              <span>{{ filter.name }}: {{ filter.labels }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../../node_modules/vue-popperjs/dist/vue-popper.css'
import AdExpirationWarning from './AdExpirationWarning'
import Popper from 'vue-popperjs'
import confettiBackground from 'campaigns/confetti-image.png'
import { format } from 'date-fns'
import { removeTimeZoneAndGetDateUtil } from '../../utilities'
import { mapState } from 'vuex'

  export default {
    props: {
      ad: Object,
      attachedAdId: Number,
      requiresLowerCount: Boolean
    },

    name: 'Ad',

    data() {
      return {
        confettiBackground
      }
    },

    components: {
      AdExpirationWarning,
      Popper
    },

    computed: {
      adIsSelected() {
        return this.ad?.id === this.attachedAdId
      },

      adAttachmentUrl() {
        if(this.ad.attachments.length === 0) {
          return '';
        }

        return this.ad?.attachments[0].url
      },

      getTimeRange() {
        return this.hasTimeRange ? `${format(removeTimeZoneAndGetDateUtil(this.ad.time_range_start), 'ha')} - ${format(removeTimeZoneAndGetDateUtil(this.ad.time_range_end), 'ha')}` : null
      },

      hasTimeRange() {
        return !!this.ad?.time_range_start && !!this.ad?.time_range_end
      },

      requestedFilters() {
        if (!this.shouldDisplayAdFilters) return []

        const requestedFilters = this.ad.selected_groups.filter(selected => !!selected?.display_names)
        const mappedSelectedFilters =  requestedFilters.map(selected => {
          let value = selected.display_names
          if (['spending total', 'visiting total', 'average spend'].includes(selected.name)) {
            value = selected.display_names.map(name => name.substring(name.indexOf('(') + 1, name.lastIndexOf(')')))
          }
          return {
            name: selected.name,
            labels: value.join(', ')
          }
        })
        return mappedSelectedFilters
      },

      formattedDate() {
        return !!this.ad?.send_at_end ? format(new Date(this.ad?.send_at_end), "MM/dd") : ""
      },

      shouldDisplayAdFilters() {
        return this.ad?.retailers?.length === 1 && (this.ad?.merchant_segment_ids?.length > 0 || this.ad?.merchant_tag_ids?.length > 0)
      },

      targetRecipientText() {
        return `target ${this.ad?.credits_left} recipients or less to send this sponsored image`
      },

      displayOverlay() {
        return this.requiresLowerCount && !this.shouldDisplayAdFilters
      },

      ...mapState([
        "currentMerchant"
      ])
    },

    methods: {
      selectAd() {
        if (this.displayOverlay) { return }
        this.adIsSelected ? this.$emit('removeAd', !!this.ad.suggested_text, this.ad) :
          this.$emit('selectedAd', {
            ad: this.ad,
            attachmentUrl: this.adAttachmentUrl,
            requestedFilters: this.requestedFilters
          })
      },
    },
  }
</script>

<style scoped>
.time-range-wrapper {
  display: flex;
  flex-direction: column;
}

.time-range-wrapper p {
  margin-bottom: 0;
}

.time-range-wrapper em {
  font-size: small;
  font-style: normal;
  line-height: .8em;
}

.setting:not(:last-child) {
  margin-bottom: .6em;
}

.ad-suggested-text span {
  line-height: 1.2em;
}

.ad-container .filter-icon {
  color: #7c65f8;
  font-size: 1.2em;
  margin-right: 5px;
}

.ad-container .filters-wrapper li {
  color: #7c65f8;
}

.ad-container .filters-wrapper li span {
  color: black;
  font-size: small;
}

.branded-images-list .ads-container-wrapper .ad-container .ad-details .ad-settings > .ad-filters {
  display: block;
}

.branded-images-list .thumbnail {
  min-width: 120px;
}

.branded-images-list .ads-container-wrapper .ad-container.selected .ad-filters * {
  color: white;
}

.branded-images-list .ads-container-wrapper .has-overlay .filter-icon {
  color: rgba(124, 101, 248, 0.25);
}

.branded-images-list .ads-container-wrapper .has-overlay .filters-wrapper li {
  color: rgba(124, 101, 248, 0.25);
}

.branded-images-list .ads-container-wrapper .has-overlay .filters-wrapper li span {
  color: rgba(10,10,10,0.25);
}

</style>
